import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePages from "./pages/home";
import ForeZeroPage from "./pages/forezero";
import ContactPage from "./pages/contact";
import ScrollToTop from "./component/layout/scralltop";
import DeletionPage from "./pages/deletion";
import PrivacyPolicy from "./pages/privacy-policy";
import DataProtectionPolicy from "./pages/data-protection-policy";
import TermsAndCondition from "./pages/terms-conditions";
import AboutPage from "./pages/about";
import CSAE from "./pages/csae";

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePages />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="deletion" element={<DeletionPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="data-protection-policy" element={<DataProtectionPolicy />} />
          <Route path="terms-conditions" element={<TermsAndCondition />} />
          <Route path="csae" element={<CSAE />} />
          <Route path="*" element={<ForeZeroPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
